<template>
  <div class="m-input-box">
    <div class="m-label">
      <slot name="textFirst"></slot>
      <input class="m-input" :value="inputVal" :type="changeType"  v-model="inputVal" @input="handleInput($event)" :disabled="disabled" v-if="!showplaceHolder" @blur="blur"/>
      <input class="m-input" :value="inputVal" :type="changeType"  v-model="inputVal" :placeholder=" placeholder ||'请输入'+label.name " :disabled="disabled" @input="handleInput($event)" v-if="showplaceHolder" @blur="blur"/>
      <slot name="textLast"></slot>
    </div>
    <div v-show="errMsg !== ''" class="m-msg" :class="hintPlace">{{errMsg}}</div>
  </div>
</template>

<script>

export default {
  props: {
    disabled: {
      type: String
    },
    verify: {
      type: Array
    },
    placeholder: {
      type: String
    },
    dataList: {
      type: Object
    },
    value: {
      default: ''
    },
    hintPlace: {
      type: String,
      default: 'left'
    },
    type: {
      type: String,
      default: 'text'
    },
    label: {
      type: Object
    },
    Reg: {
      type: Object
    },
    range: {
      type: Object
    },
    length: {
      type: Object
    }
  },
  data () {
    return {
      inputVal: this.value,
      changeType: '',
      showplaceHolder: this.placeholder || this.label,
      preVal: '',
      errMsg: ''
    }
  },
  methods: {
    say () {
      this.mVerify(this.inputVal)
    },
    //      changeValue (required) {
    //        setTimeout(()=>{
    //          let errMsg = this.errMsg.length>0?false:true
    //          this.$emit('input', this.inputVal, required === false ? false:errMsg) //触发 input 事件，并传入新值
    //        },200)
    //      },
    handleInput (event) {
      this.$nextTick(() => {
        let value = event.target.value
        this.$emit('input', value, this.errMsg === '', this.dataList) //触发 input 事件，并传入新值
      })
    },
    mVerify (newVal) {
      if (this.verify && this.verify.length > 0) {
        for (let i = 0; i < this.verify.length; i++) {
          if (this.verify[i] === 'required') {
            if (newVal === '' || !newVal) {
              this.errMsg = `${this.label ? this.label.name : '当前输入框'}不能为空`
              break
            }
          }
          if (this.verify[i] === 'reg') {
            let reg = new RegExp(this.Reg.code)
            if (!reg.test(newVal)) {
              this.errMsg = this.Reg.hint
              break
            }
          }

          if (this.verify[i] === 'range') {
            if (this.range) {
              let change = {
                pass: true,
                newVal: '',
                min: '',
                max: ''
              }
              let type = ''
              if (this.type === 'number') {
                change.newVal = parseInt(newVal)
                change.min = parseInt(this.range.min)
                change.max = parseInt(this.range.max)
                if ((/^\d+$/g).test(newVal)) {
                  change.pass = true
                } else {
                  change.pass = false
                }
                type = '整数'
              } else if (this.type === 'double') {
                change.newVal = parseFloat(newVal)
                change.min = parseFloat(this.range.min)
                change.max = parseFloat(this.range.max)
                type = '数值'
              }
              if (change.newVal < change.min || change.newVal > change.max || !change.pass) {
                this.errMsg = `请输入${this.range.min}-${this.range.max}之间的${type}`
              }
            }
            break
          }

          if (this.verify[i] === 'length') {
            if (this.length && this.length.min && newVal.length < this.length.min) {
              this.errMsg = `不能少于${this.length.min}个字符`
              break
            } else if (this.length && this.length.max && newVal.length > this.length.max) {
              this.errMsg = `不能大于${this.length.max}个字符`
              break
            }
          }

          this.errMsg = ''
        }
      }
    },
    blurHandel () {
      setTimeout(function () {
        var scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0
        window.scrollTo(0, Math.max(scrollHeight - 1, 0))
      }, 300)
    },
    blur () {
      if (this.errMsg === '') {
        this.mVerify(this.inputVal)
      }
      this.blurHandel()
    }

  },
  watch: {
    'value' (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.inputVal = newVal
      }
    },
    'errMsg' (newVal, oldVal) {
      //        this.$emit('input', this.inputVal, this.errMsg===''?true:false )
    },

    'inputVal' (newVal, oldVal) {
      if ((newVal && !oldVal) || (newVal && oldVal) || (!newVal && oldVal)) {
        this.mVerify(newVal)
        //            this.$emit('input', this.inputVal, this.errMsg===''?true:false )
      }
    },
    'type': {
      handler (newVal, oldVal) {
        if (newVal === 'number') {
          this.changeType = 'tel'
        } else if (newVal === 'double') {
          this.changeType = 'number'
        }
      },
      immediate: true,
      deep: true
    }
  }
}
</script>
<style ref="stylesheet/scss" lang="scss" scoped>
  @import "@/assets/style/variables.scss";

  .m-input-box {
    font-size: 15px;
    /*border-bottom: 1px solid #f5f5f5;*/
    background-color: #ffffff;
    padding: 0 15px;
  }

  .m-input {
    box-sizing: border-box;
    padding: 15px 0;
    border: none;
  }

  .m-label {
    display: flex;
    align-items: center;
  }

  .m-label>div{
    flex: 0 0 24%;
    line-height: 1;
  }
  .m-label>input+div{
    text-align: right;
    flex: 0 0 40px;
    line-height: 1;
  }
  .m-label > input {
    flex: 1;
  }

  .left{
    text-align: left;
  }
  .right{
    text-align: right;
  }
  .left{
    text-align: center;
  }
  .m-msg{
    display: inline-flex;
    width: 100%;
    height: 30px;
    font-size: 14px;
    color: #ff0000;
    background-color: #ffffff;
    padding-left: 85px;
  }
</style>
